<template>
    <div
            v-if="broughtByOrgMember"
            class="brought-by mb-5"
    >
        <div class="brought-by-content d-flex justify-content-between">
            <div class="brought-by-text">
                <div class="brought-by-name text-truncate">
                    {{ broughtByOrgMember.fullName }}
                </div>
                <div
                        v-if="broughtByOrgMember.title"
                        class="brought-by-details text-truncate"
                >
                    {{ broughtByOrgMember.title }},
                </div>
                <div
                        v-if="broughtByOrgMember.company"
                        class="brought-by-details text-truncate"
                >
                    {{ broughtByOrgMember.company }}
                </div>
                <div
                        v-if="broughtByOrgMember.phoneNumber || broughtByOrgMember.email"
                        class="mt-4 d-flex"
                >
                    <div
                            v-if="broughtByOrgMember.phoneNumber"
                            class="brought-by-details mr-3"
                    >
                        {{ formatStringPhoneUS(broughtByOrgMember.phoneNumber) }}
                    </div>

                    <div
                            v-if="broughtByOrgMember.email"
                            class="brought-by-details brought-by-email"
                    >
                        <a :href="`mailto:${broughtByOrgMember.email}`">Email Me</a>
                    </div>
                </div>
            </div>
            <div
                    v-if="broughtByOrgMember.avatar || broughtByOrgMember.companyLogo"
                    class="d-flex flex-column align-items-end"
            >
                <b-img
                        v-if="broughtByOrgMember.avatar"
                        :src="broughtByOrgMember.avatar"
                        class="brought-by-avatar mb-2"
                />
                <b-img
                        v-if="broughtByOrgMember.companyLogo"
                        :src="broughtByOrgMember.companyLogo"
                        class="brought-by-company-logo"
                />
            </div>
        </div>
    </div>
</template>

<script>
import './BroughtBy.scss';
import {formatStringPhoneUS} from "@milestoneslabs/milestones-ui-kit/src/helpers/phoneHelper";

export default {
    name: "BroughtBy",
    props: {
        broughtByOrgMember: {
            default: null,
        }
    },

    methods: {
        formatStringPhoneUS,
    }
};
</script>
